import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { API_CONFIG } from '../config/api';

const NewAparatForm = () => {
    const [nazivAparata, setNazivAparata] = useState('');
    const [idBroj, setIdBroj] = useState('');
    const [idUstanova, setIdUstanova] = useState('');
    const [ustanove, setUstanove] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState('');
    // const navigate = useNavigate();

    useEffect(() => {
        const fetchUstanove = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('Autentikacija neuspjela. Molimo prijavite se ponovno.');
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(API_CONFIG.ENDPOINTS.USTANOVE, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Greška prilikom dohvaćanja ustanova.');
                }

                const data = await response.json();
                setUstanove(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUstanove();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess('');

        const token = localStorage.getItem('token');
        if (!token) {
            setError('Autentikacija neuspjela. Molimo prijavite se ponovno.');
            return;
        }

        try {
            const response = await fetch(API_CONFIG.ENDPOINTS.APARATI, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    naziv_aparata: nazivAparata,
                    id_broj: idBroj,
                    id_ustanova: idUstanova,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Greška prilikom kreiranja aparata.');
            }

            setSuccess('Aparat uspješno dodan!');
            setNazivAparata('');
            setIdBroj('');
            setIdUstanova('');
            // Optional: Redirect after a short delay
            // setTimeout(() => navigate('/dashboard'), 2000);
        } catch (err) {
            setError(err.message);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[50vh] text-gray-600">Učitavanje...</div>
        );
    }

    if (error) {
        return (
            <div className="max-w-md mx-auto p-4">
                <div className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">Greška: {error}</div>
            </div>
        );
    }

    return (
        <div className="max-w-md mx-auto">
            <div className="p-8 bg-white rounded-lg shadow-sm border border-gray-200 w-full">
                <div className="flex items-center justify-center mb-6">
                    <FontAwesomeIcon icon={faPlusCircle} className="text-blue-500 text-3xl mr-3" />
                    <h2 className="text-2xl font-bold text-gray-800">Novi Aparat</h2>
                </div>
                {success && <div className="p-3 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">{success}</div>}
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="nazivAparata" className="block text-sm font-medium text-gray-700">Naziv aparata</label>
                        <input
                            type="text"
                            id="nazivAparata"
                            value={nazivAparata}
                            onChange={(e) => setNazivAparata(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="idBroj" className="block text-sm font-medium text-gray-700">ID broj</label>
                        <input
                            type="text"
                            id="idBroj"
                            value={idBroj}
                            onChange={(e) => setIdBroj(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="idUstanova" className="block text-sm font-medium text-gray-700">Ustanova</label>
                        <select
                            id="idUstanova"
                            value={idUstanova}
                            onChange={(e) => setIdUstanova(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            required
                        >
                            <option value="">-- Odaberite ustanovu --</option>
                            {ustanove.map((u) => (
                                <option key={u.id_ustanova} value={String(u.id_ustanova)}>
                                    {u.naziv_ustanove}
                                </option>
                            ))}
                        </select>
                    </div>
                    <button
                        type="submit"
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Dodaj aparat
                    </button>
                </form>
            </div>
        </div>
    );
};

export default NewAparatForm;
